export default {"src":"/_next/static/media/peaceOfMind.2dd67580.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};